import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';
import useIsMobile from '../../hooks/useIsMobile';
import useLogout from '../../hooks/useLogout';

/** Renders children on desktop; on phones shows a "use a computer" notice instead (e.g. the SuperAdmin panel). */
const DesktopOnly = ({ children }) => {
	const isMobile = useIsMobile();
	const handleLogout = useLogout();

	if (!isMobile) return children;

	return (
		<div className="desktop-only-notice">
			<h1 className="h4">Desktop only</h1>
			<p>This section isn&apos;t available on phones. Please open Alert Panel on a computer.</p>
			<Button variant="outline-danger" onClick={handleLogout}>Sign out</Button>
		</div>
	);
};

DesktopOnly.propTypes = {
	children: PropTypes.node.isRequired,
};

export default DesktopOnly;
